import React, {Fragment, useRef} from "react";
import { Link , NavLink} from "react-router-dom";
import {Skeleton} from "@mui/material";
import LazyLoad from "react-lazy-load";
const Home_Section_C = (props) => {
    return (


        <Fragment>


            <style jsx>{`

         

                .box_scroll_cat_home_horizontal {
                    position: relative;
                    -webkit-box-pack: initial;
                    align-items: normal;
                    display: flex;
                    flex: unset;
                    flex-flow: row;
                    margin-bottom: 6px;
                    overflow-x: auto;
                    overflow-y: hidden !important;
                    padding-top: 2px;
                    place-content: normal;
                    flex-direction: row;
                    flex-wrap: wrap;
                    gap: 13px;
                }

                .item_cat_boxbk_home, .item_cat_boxbk_home a {
                    align-content: center;
                    align-items: center;
                    cursor: pointer;
                    display: flex;
                    flex-direction: column;
                    flex-wrap: wrap;
                    justify-content: center;
                }

                .btn-cat-image_home {
                    background-color: #ffffff;
                    transition: background-color 0.3s ease;
                    border-radius: 9px;
                    width: 230px;
                    height: 230px;
                    max-height: 230px;
                    min-width: 230px;
                    margin-left: 1px;
                    margin-right: 7px;
                    padding-bottom: 3px;
                    padding-top: 18px;
                }
                .bg-card-cat-home{
                    z-index: 0;
                    position: absolute;
                    width: 230px;
                    height: 230px;
                    transform: rotate(-3.36deg);
                    flex-shrink: 0;
                    border-radius: 19.335px;
                    transition: background-color 0.3s ease;
                    background: #01a3d4;
                }

                .image-cat-boxbk_home {
                    width: 90px;
                    position: relative;
                    bottom: 18px;
                    height: 90px;
                }

                .btn-cat-image_home {
                    z-index: 1;
                    border: none;
                    background-color: white;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                }

                .title-cat-boxbk_home {

                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    text-align: center;
                    height: 50px;
                    font-size: 14px;

                }


            


                .item_cat_boxbk_home:hover .btn-cat-image_home{
                    background-color: #01a3d4;
                  
                }

                .item_cat_boxbk_home:hover .bg-card-cat-home {
                    background-color: white;
                }

                .item_cat_boxbk_home:hover .title-cat-boxbk_home {
                    color: white !important;
                }

                @media only screen and (max-width:768px) {

                    .box_scroll_cat_home_horizontal {
                        display: flex;
                        flex-wrap: nowrap;
                      
                    }
                
                }



            `}</style>


            <div className={"cat-home-page"}>

                <div style={{"marginBottom":"36px","display":"flex","alignContent":"center","justifyContent":"center"}}>
                    <span style={{"fontSize":"20px","fontFamily":"iran","paddingRight":"56px","paddingLeft":"56px","borderBottomRightRadius":"10px","borderBottomLeftRadius":"10px","paddingBottom":"6px","backgroundColor":"white","fontWeight":"700"}}>دسته بندی محصولات</span>
                </div>

                <div className={"container_bk_home"}>
                    <div className="box_scroll_cat_home_horizontal">

                        {

                            props.data_category_box.length == 0 ? (
                                <React.Fragment>

                                    <Skeleton variant="rectangular"
                                              style={{width: "100%", height: "180px", borderRadius: "10px"}}/>

                                </React.Fragment>


                            ) : (


                                props.data_category_box.map((item_post, index) => {

                                    return (

                                        <div className="item_cat_boxbk_home">
                                            {
                                                <NavLink className={"btn-cat-image_home"} reloadDocument={true} to={"/product-category/" + String(item_post.slug)} >

                                                    <LazyLoad threshold={0.95}>
                                                        <img className="image-cat-boxbk_home"
                                                             src={item_post.image_src}/>
                                                    </LazyLoad>
                                                    <span className={"title-cat-boxbk_home"}>{item_post.name}</span>
                                                </NavLink>

                                            }
                                            <div className="bg-card-cat-home"></div>

                                        </div>

                                    );

                                })

                            )
                        }

                    </div>
                </div>

            </div>

        </Fragment>
    );
}

export default Home_Section_C;